module.exports = __webpack_public_path__ + "879d1282bbb2070f688ce36a992cd509.jpg";


//////////////////
// WEBPACK FOOTER
// ./public/content/assets/3021_teaser_image.jpg
// module id = 615
// module chunks = 0